module.exports = __webpack_public_path__ + "img/video-m-1.479b8699.png";